import React from 'react'
import {
  Box,
  Typography,
  useTheme,
  useMediaQuery
} from '@mui/material'

const AdminPageWrapper = ({
  title,
  subtitle = null,
  children,
  maxWidth = 'xl'
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3, md: 4 }, // Responsive padding
        maxWidth: maxWidth,
        mx: 'auto',
        width: '100%'
      }}
    >
      <Typography
        variant={isMobile ? "h5" : "h4"}
        component="h1"
        gutterBottom
        sx={{
          fontWeight: 500,
          mb: subtitle ? 1 : 3
        }}
      >
        {title}
      </Typography>

      {subtitle && (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 3 }}
        >
          {subtitle}
        </Typography>
      )}

      {children}
    </Box>
  )
}

export default AdminPageWrapper